import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


// Subject service will allow you to enable bi-directional communication for a parent component and its children.
// https://www.youtube.com/watch?v=rdK92pf3abs

// How to trigger function from one component to another in angular2?
// https://stackoverflow.com/questions/40313770/how-to-trigger-function-from-one-component-to-another-in-angular2

@Injectable()
export class FunctionCallService
{
    private defferedPromptSubject = new Subject<any>();

    private addToHomeScreenSubject = new Subject<any>();

    public addToHomeScreenIOSSubject = new BehaviorSubject<any>(false);

    private checkForUpdateSubject = new Subject<any>();
    
    private getBrowserInfoSubject = new Subject<any>();

    defferedPrompt: any;

    constructor()
    {
        // console.log('Pwa Service Constructor');
    }  

    // -------------------------------------------------------
    // Set and Get the Deffered Prompt if Any
    // -------------------------------------------------------
    storedDefferedPrompt(defferedPrompt) 
    {
        this.defferedPromptSubject.next(defferedPrompt);
    }

    get storedDefferedPromptEvent$() 
    {
        return this.defferedPromptSubject.asObservable();
    }  


    // -------------------------------------------------------
    // Add to Home Screen
    // -------------------------------------------------------
    addToHomeScreenService(event) 
    {
        this.addToHomeScreenSubject.next(event);
    }

    get addToHomeScreenEvents$() 
    {
        return this.addToHomeScreenSubject.asObservable();
    }  


    // -------------------------------------------------------
    // Add to Home Screen IOS
    // -------------------------------------------------------
    addToHomeScreenIOSService(event) 
    {
        console.log('SAFARI BROWSER FOUND ', event);
        this.addToHomeScreenIOSSubject.next(event);
    }

    get addToHomeScreenIOSEvents$() 
    {
        return this.addToHomeScreenIOSSubject.asObservable();
    }  

    // -------------------------------------------------------
    // Check for Updates
    // -------------------------------------------------------
    checkForUpdateService(event) 
    {
        this.checkForUpdateSubject.next(event);
    }

    get checkForUpdateEvents$() 
    {
        return this.checkForUpdateSubject.asObservable();
    }    


    // -------------------------------------------------------
    // Get Browser Info
    // -------------------------------------------------------
    getBrowserInfoService(event) 
    {
        this.getBrowserInfoSubject.next(event);
    }

    get getBrowserInfoEvents$() 
    {
        return this.getBrowserInfoSubject.asObservable();
    }      

}
